import * as constants from '@/store/constants'
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import service from '@/api/UserService'
import store from '@/store'
import router from '@/router'
import toast from '@/mixins/toast'

export default {

	 [types.ACTION_FIND_USER_BY_ID]: ({commit}, payload) => {
		service.fetchUserById(payload)
         .then( (response) => {
                       if (response) {
                           store.commit(types.MUTATE_USER, response)
                           store.commit(types.MUTATE_MODIFIED, false)
                       }
                   })
    },

   [types.ACTION_FIND_USER_BY_USERNAME]: ({commit}, payload) => {
    service.fetchUserByUsername(payload)
         .then( (response) => {
                       if (response) {
                           commit(types.MUTATE_USER_ID, response.id)
                           commit(types.MUTATE_USERNAME, response.username)
                           commit(types.MUTATE_USER_FIRSTNAME, response.firstname)
                           commit(types.MUTATE_USER_LASTNAME, response.lastname)
                           commit(types.MUTATE_USER_PERMISSION, response.permission)
                           commit(types.MUTATE_USER_AGENCY_ID, response.agency_id)
                           commit(types.MUTATE_USER_AGENCY_NAME, response.agency_name)

                           if (response.permission === constants.ADMIN)
                              router.replace('/home')
                           else 
                              router.replace('/home-user')
                       }
                   })
    },

    [types.ACTION_ADD_USER]: ({commit}, payload) => {
        service.addUser(payload)
               .then ( (response) => {
                      if (response) {
                          store.commit(types.MUTATE_MODIFIED, false)
                          router.push('/login')
                          toast.success("Your request has been submitted to DLT Team for review.  You will receive an email notification once your request is approved.","Thank you!")
                      }
               })
    },

    [types.ACTION_UPDATE_USER]: ({commit}, payload) => {
        service.updateUser(payload)
            .then( (response) => {
                  if (response) {                      
                      store.commit(types.MUTATE_MODIFIED, false)
                      toast.success("Saved successfully")    
                  }
            })
    }    
}


// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js